<template>
	<div>
		<q-table
			ref="table"
			:data="data"
			:columns="columns"
			row-key="id"
			:pagination.sync="server_pagination"
            :filter="filter"
			@request="request"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5,10,50,100]"
			binary-state-sort
			class="q-mt-lg"
			>

            <template slot="top" slot-scope="props" :props="props">
				<q-search
					v-model="filter"
					:debounce="1500"
					icon="far fa-search"
					:placeholder="$t('search')"
				/>

				<div class="col" />
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
				{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
                    <q-td key="group_training_id" :props="props">
						{{ props.row.group_training_id }}
					</q-td>

					<q-td key="group_training_title" :props="props">
						{{ props.row.group_training_title }}
					</q-td>

					<q-td key="percent" :props="props">
						{{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
					</q-td>

					<q-td key="score" :props="props">
						{{ props.row.score ? props.row.score.toFixed(2) : '' }}
					</q-td>

					<q-td key="result_date" :props="props">
						{{ getDateFormated(props.row.result_date) }}
					</q-td>

                    <q-td key="status" :props="props" auto-width >
                        <q-chip small :color="getColorStatus(props.row.status)" >
                            {{ $t(getStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>

					<q-td key="id" :props="props">
						<q-btn v-if="props.row.status === 1" flat round color="secondary" icon="far fa-eye" @click="showCertificate(props.row.group_training_id)" >
                            <q-tooltip>
                                {{ $t('view_certificate_tooltip')}}
                            </q-tooltip>
                        </q-btn>
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<certificate :show="show_certificate" :data="certificate_data" @hideCertificate="hideCertificate" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import Certificate from 'components/Certificate'

export default {
    name: 'UserReportCourseResultsTab',

	components: {
        'certificate': Certificate
    },

    data() {
        return {
			loading: false,
            filter: '',
			certificate_data: [],
			show_certificate: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'group_training_id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'group_training_id',
                    sortable: false,
                },
                {
                    name: 'group_training_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'group_training_title',
                    sortable: false,
                },
                {
                    name: 'percent',
                    required: true,
                    label: 'user_performance',
                    align: 'left',
                    field: 'percent',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: false,
				},
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
				{
                    name: 'id',
                    required: true,
                    label: 'certificate',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

		getHeaderUrlencoded() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "title": this.filter,
                "ordering": order_by,
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_group_training_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.data = []

                response.data.results.forEach(result => {
                    this.data.push(result)
                })
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        loadReports() {
			if (this.reports_store)
				this.report_list = this.reports_store.filter((obj) => {
					return (
						obj.slug_type === 'users' &&
						obj.url != 'https://www.take5.com.br' &&
						obj.url != ''
					)
				})
		},

        getDateFormated(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
		},

		showCertificate(idTraining){
            this.$q.loading.show()

			let data = {
                'user_id': this.selected_user
            }

			this.$axios.post(`/etraining_courses/group_training/${idTraining}/get_group_training_user_result_certificate/`, this.$qs.stringify(data), this.getHeaderUrlencoded)
			.then(response => {
				this.certificate_data = response.data
                this.show_certificate = true
			})
			.catch(e => {
				console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            });
        },

		hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        getStatus(status) {
            if (status == 1) return 'aproved'
            else if (status == 2) return 'reproved'
            else if (status == 3) return 'restarted'
            else return ''
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'negative'
            else if (status == 3) return 'warning'
            else return ''
        },
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()
        this.loadReports()

		this.request({ pagination: this.server_pagination })
	}
}
</script>

<style>

</style>
